import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "מדיניות פרטיות | ישיבת תורת חיים" },
    ],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <section className="container mx-auto px-4 py-16 max-w-3xl" dir="rtl">
      <h1 className="font-display text-4xl font-bold text-primary mb-8">מדיניות פרטיות</h1>

      <div className="prose prose-lg space-y-6 text-foreground/80 leading-relaxed">
        <p>
          מוסדות תורת חיים מכבדים את פרטיות המשתמשים באתר. מדיניות זו מפרטת כיצד אנו אוספים, משתמשים ושומרים את המידע האישי שאתם מוסרים לנו.
        </p>

        <h2 className="font-display text-2xl font-bold text-primary mt-8 mb-3">מה המידע שאנו אוספים?</h2>
        <p>אנו עשויים לאסוף את פרטי הקשר שתמסרו לנו דרך טופס "צור קשר" באתר, לרבות:</p>
        <ul className="list-disc list-inside space-y-2">
          <li>שם</li>
          <li>כתובת דוא"ל</li>
          <li>מספר טלפון</li>
          <li>תוכן ההודעה</li>
        </ul>

        <h2 className="font-display text-2xl font-bold text-primary mt-8 mb-3">למה אנו אוספים את המידע?</h2>
        <p>המידע נאסף אך ורק לצורך יצירת קשר חזרה, מתן מענה לפניות, וניהול תהליך הרשמה/התקבלות לישיבה.</p>

        <h2 className="font-display text-2xl font-bold text-primary mt-8 mb-3">שמירת מידע</h2>
        <p>
          המידע נשמר במאגר מאובטח (Cloudflare D1) ואינו מועבר לצדדים שלישיים. אנו שומרים את המידע כל עוד הוא נדרש לצורך המטרות המפורטות לעיל, וניתן למחוק אותו לפי פנייה אלינו.
        </p>

        <h2 className="font-display text-2xl font-bold text-primary mt-8 mb-3">זכויות המשתמש</h2>
        <ul className="list-disc list-inside space-y-2">
          <li>זכות לעיין במידע האישי השמור אצלנו</li>
          <li>זכות לתקן מידע שגוי</li>
          <li>זכות למחוק את המידע ("זכות להשמיטה")</li>
          <li>זכות לערור על שימוש במידע</li>
        </ul>
        <p>
          לבירורים ופניות בנושא פרטיות, ניתן לפנות אלינו בדוא"ל:{" "}
          <a href="mailto:toratchaimbb@gmail.com" className="text-primary underline">toratchaimbb@gmail.com</a>.
        </p>

        <h2 className="font-display text-2xl font-bold text-primary mt-8 mb-3">עוגיות וטכנולוגיות מעקב</h2>
        <p>
          האתר משתמש בעוגיות הכרחיות לצורך אבטחת אזור הניהול (Cloudflare Access). אנו לא משתמשים בעוגיות מעקב, פרסום או אנליטיקה של צד שלישי.
        </p>

        <h2 className="font-display text-2xl font-bold text-primary mt-8 mb-3">עדכוני מדיניות</h2>
        <p>מדיניות זו עודכנה לאחרונה בחודש יוני 2026. במידה ויבוצעו שינויים מהותיים, נפרסם עדכון בעמוד זה.</p>
      </div>
    </section>
  );
}
